import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IBooking } from '@shared/interfaces/bookings.interface';

@Injectable({
  providedIn: 'root'
})
export class BookingUtilsService {
  static messageService: any;

  static calculatePendingAmount(booking: any) {
    booking.pending_amount = booking.total_amount - booking.total_paid;
    return booking.pending_amount;
  }

  static calculateTotalAmount(booking: any) {
    let total_amount = 0;
    if (booking.services && booking.services.length > 0) {
      booking.services = booking.services.map((service: any) => {
        service.subtotal = (service.unit_price * (1-(service.discount/100))) * service.units;
        return service;
      });

      const totalPrice = booking.services.reduce((accumulator: number, service: any) => {
        return accumulator + service.subtotal;
      }, 0);

      total_amount = totalPrice;
    }
    return total_amount;
  }


  static calculateTotalPrice(booking: any): IBooking {
    booking.services = booking.services.map((service: any) => {
      service.subtotal = service.unit_price * service.units;
      return service;
    });
    return booking;
  }

  static getBillingAddress(customer: any) {
    if(customer.addresses?.length > 0){
      const billingAddress = customer.addresses.find(
        (address: { alias: string; }) => address.alias === 'Facturación');
      if (billingAddress === null) {
        return `${billingAddress.street_name} ${billingAddress.street_number} ${billingAddress.city} ${billingAddress.country} ${billingAddress.postal_code}`;
      } else {
        const anotherAddress = customer.addresses[0];
        if (anotherAddress) {
          return `${anotherAddress.street_name} ${anotherAddress.street_number} ${anotherAddress.city} ${anotherAddress.country} ${anotherAddress.postal_code}`;
        } else {
          return '';
        }
      }
    }
    return '';
  }

  static markFormAsTouched(form: FormGroup) {
    Object.values(form.controls).forEach(control => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.markFormAsTouched(control);
      }
    });
  }

  static handleValidationErrors(validationData: any) {
    Object.keys(validationData).forEach(key => {
      const errorMessages = validationData[key];
      const messageToast = ` ${errorMessages.join(", ")}`;
      this.messageService.add({ severity: 'error', summary: 'Error de validación', detail: messageToast, life: 30000 });
    });
  }
}
